"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "File-Date": "2022-06-28"
};
//# sourceMappingURL=meta.json.js.map